/**
 * @generated SignedSource<<2e2a23bcf0a84021ab2a6a437d11ef0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PublicProfileStatus = "ACTIVE" | "INACTIVE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftPdpCreator_nftItem$data = {
  readonly creatorAddress: {
    readonly address: string | null;
    readonly publicProfile: {
      readonly bio: string | null;
      readonly discordLink: string | null;
      readonly facebookLink: string | null;
      readonly instagramLink: string | null;
      readonly profileName: string | null;
      readonly status: PublicProfileStatus | null;
      readonly twitterLink: string | null;
      readonly webLink: string | null;
      readonly wikipediaLink: string | null;
    } | null;
    readonly publicProfileUrl: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address" | "NftPdpCreatorItems_creatorAddress">;
  } | null;
  readonly " $fragmentType": "NftPdpCreator_nftItem";
};
export type NftPdpCreator_nftItem$key = {
  readonly " $data"?: NftPdpCreator_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreator_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "creatorItemCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpCreator_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftAvatarCircle_address"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "itemCount",
              "variableName": "creatorItemCount"
            }
          ],
          "kind": "FragmentSpread",
          "name": "NftPdpCreatorItems_creatorAddress"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicProfileUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bio",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instagramLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "twitterLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "facebookLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "wikipediaLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discordLink",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "e1f0eaa83af2f2ce59998d8a2962d7c2";

export default node;
